export default function pathFromName(name) {
  if (typeof name === "string") {
    return name.split("/")
  }

  return name
}



// WEBPACK FOOTER //
// ../ui-kit/src/lib/named-paths/pathFromName.js